import React from 'react';
import { Outlet } from 'react-router-dom';
import Adminsidebar from './Adminsidebar';
import '../assets/dashcss/core.css';
import '../assets/dashcss/demo.css';
import '../assets/dashcss/theme-default.css';

function Admindashboard() {
  return (
    <>
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <Adminsidebar />
        <Outlet />
      </div>
    </div>
    </>
  );
}

export default Admindashboard;